import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Button from './Button'
import Icon from './Icon'
import Title from './typography/Title'

function CollapsibleActionIcon ({ icon, expanded }) {
  return (
    <Icon
      icon={icon}
      className={classnames(
        { 'icon--rotate-180': !expanded },
        'icon ml2 flex-none'
      )}
    />
  )
}

export function CollapsibleActionButton ({
  btnLabel,
  extraClass,
  icon,
  onClick,
  expanded,
  ariaLabel,
  variation,
  classNamePrefix
}) {
  return (
    <Button
      variation={variation || 'plain'}
      onClick={onClick}
      ariaLabel={ariaLabel}
      ariaExpanded={expanded}
      extraClass={classnames(
        {
          [`${classNamePrefix}__element__action-button text-left`]: classNamePrefix
        },
        extraClass
      )}
      icon={!classNamePrefix ? icon : undefined}
    >
      <span>{btnLabel}</span>
      {typeof icon === 'string' && classNamePrefix ? (
        <CollapsibleActionIcon icon={icon} expanded={expanded} />
      ) : typeof icon !== 'string' ? (
        icon
      ) : null}
    </Button>
  )
}

function CollapsibleElement ({
  Element = 'article',
  titleElement,
  expanded,
  onClick,
  btnLabel,
  collapsibleContent,
  classNamePrefix,
  icon
}) {
  return (
    <Element className={`${classNamePrefix}__element`}>
      <Title
        extraClass={classNamePrefix && `${classNamePrefix}__element__title`}
        Element={titleElement || 'h3'}
        size={4}
      >
        <CollapsibleActionButton
          expanded={expanded}
          onClick={onClick}
          classNamePrefix={classNamePrefix}
          icon={icon}
          btnLabel={btnLabel}
        />
      </Title>
      {expanded && collapsibleContent}
    </Element>
  )
}

CollapsibleElement.propTypes = {
  btnLabel: PropTypes.string,
  collapsibleContent: PropTypes.any,
  classNamePrefix: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  expanded: PropTypes.bool
}

export default CollapsibleElement
